import PropTypes from 'prop-types';
import { Row, Col } from "reactstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { useForm } from "react-hook-form";
import { selectTiposParametros } from '../../services/tipos-parametros-service';
import { crearOEditarParametro } from '../../services/parametros-service';

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const FormParametros = ({ modalState, onSaved }) => {
    const { parametro } = modalState.data;
    const [tiposParametros, setTiposParametros] = useState([]);

    const defaultValues = {
        id: parametro.id || "",
        nombre: parametro.nombre || "",
        descripcion: parametro.descripcion || "",
        tipos_parametros_id: parametro.tipos_parametros_id
            ? {
                  label: parametro.nombre_tipo_parametro,
                  value: parametro.tipos_parametros_id,
              }
            : "",
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [parametro]);

    const onCreateParametro = async (parametro) => {
        parametro.tipos_parametros_id = parametro.tipos_parametros_id.value;
        const resp = await crearOEditarParametro(parametro);
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSaved();
    };

    useEffect(async () => {
        const resp = await selectTiposParametros();
        if (!resp.status) return toast.error(resp.message);

        const tiposParametros = resp.data.map((tipoParametro) => {
            return {
                value: tipoParametro.id,
                label: tipoParametro.nombre,
            };
        });

        setTiposParametros(tiposParametros);
    }, []);

    return (
        <FormModal
            size="lg"
            form={form}
            id="formtipoParametro"
            onSubmit={onCreateParametro}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    type="hidden"
                    name="id"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={6}>
                    <InputController
                        label="Nombre"
                        errors={form.formState.errors}
                        control={form.control}
                        name="nombre"
                        rules={REQUIRED_RULE}
                        placeholder="Nombre tipo parametro"
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        options={tiposParametros}
                        label="Tipos Parametros"
                        errors={form.formState.errors}
                        control={form.control}
                        name="tipos_parametros_id"
                        rules={REQUIRED_RULE}
                        placeholder="Tipo Parametro"
                    />
                </Col>
                <Col sm={12}>
                    <InputController
                        type="textarea"
                        label="Descripción"
                        errors={form.formState.errors}
                        control={form.control}
                        name="descripcion"
                        rules={REQUIRED_RULE}
                        placeholder="Descripción"
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormParametros.propTypes = {
    modalState: PropTypes.object,
    onSaved: PropTypes.func
}

export default FormParametros;
